var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"d-flex"},[_c('RouterGoAlertListBtn'),_vm._m(0)],1),_c('pending-card',{attrs:{"id":_vm.gt}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pb-6 pl-4"},[_c('h2',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Revisar diagnosticos")])])
}]

export { render, staticRenderFns }